import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_CHECKOUT = {
    getCheckoutInfo: async (checkoutId) => {
        return API.get('/checkout/' + checkoutId).then(res => res.data);
    },
    updateTransferenciaMethod: async (presupuestoId, presupuesto) => {
        return API.post('/checkout/' + presupuestoId + '/transferencia', presupuesto, headers).then(res => res.data);
    },
    payWithTransfer: async (checkoutId, data) => {
        return API.post('/checkout-transfer-payment/' + checkoutId, data, headers).then(res => res.data);
    },
    transferCheckoutDone: async (checkoutId, data) => {
        return API.post('/checkout-transfer-done/' + checkoutId, data).then(res => res.data);
    },
    transferCheckoutDenied: async (checkoutId, data) => {
        return API.post('/checkout-transfer-denied/' + checkoutId, data).then(res => res.data);
    }
}